import { FormActions } from "../../components/common/FormActions";
import {
  createViewAction,
  formatDate,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_WAGES_PAYMENTS_HISTORY } from "../../utils/urls";
import {
  BooleanTags,
  PaymentStatusTag,
} from "../../components/common/registerUtils";
import { CONFIRMED, REJECTED } from "../../utils/constants";
import { useToasts } from "../common/useToasts";
import useSet from "../common/useSet";
import { API_WAGE_PAYMENTS_HISTORY } from "../../utils/apis";
// import dayjs from "dayjs";

const useWagesPaymentHistory = () => {
  const tableColumns = () => [
    { id: "staff_name", header: "Staff Name", filter: { type: "text" } },
    { id: "staff_code", header: "Staff Code", filter: { type: "text" } },
    { id: "staff_type", header: "Staff Type", filter: { type: "text" } },

    { id: "period_start", header: "Period Start", filter: { type: "date" } },
    { id: "period_end", header: "Period End", filter: { type: "date" } },

    { id: "total_wage", header: "Total Wage" },
    { id: "amount", header: "Paid Amount" },
    { id: "payment_method", header: "Payment Method" },
    { id: "status", header: "Payment Status" },

    { id: "payment_date", header: "Payment Date", filter: { type: "date" } },
    { id: "created_by", header: "Created By" },

    { id: "actions", header: "Actions" },
  ];

  const tableData = (data: any[]) =>
    data?.map((item: any) => {
      const wage = item?.wage_calculation_details;

      return {
        id: item?.id,

        staff_name: wage?.staff_name,
        staff_code: wage?.staff_code,
        staff_type: wage?.staff_type,

        period_start: formatDate(wage?.period_start),
        period_end: formatDate(wage?.period_end),

        total_wage: numberFormat(wage?.total_wage),
        amount: numberFormat(item?.amount),
        payment_method: item?.payment_method,

        status: <PaymentStatusTag status={item?.status} />,
        payment_date: formatDateTime(item?.payment_date),

        created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,

        actions: (
          <FormActions
            actions={[createViewAction(URL_WAGES_PAYMENTS_HISTORY, item?.id)]}
          />
        ),
      };
    }) || [];

  const viewData = (item: any) => {
    const wage = item?.wage_calculation_details;

    return {
      sections: [
        {
          title: "Staff & Wage Details",
          fields: {
            "Staff Name": wage?.staff_name,
            "Staff Code": wage?.staff_code,
            "Staff Type": wage?.staff_type,

            "Period Start": formatDate(wage?.period_start),
            "Period End": formatDate(wage?.period_end),

            "Total Collections": numberFormat(wage?.total_collections),
            "Commission %": wage?.commission_percentage,
            "Commission Amount": numberFormat(wage?.commission_amount),
            "Fixed Wage": numberFormat(wage?.fixed_wage_amount),
            "Total Wage": numberFormat(wage?.total_wage),

            Approved: <BooleanTags status={wage?.is_approved} />,
            "Payment Status": (
              <PaymentStatusTag status={wage?.payment_status} />
            ),

            "Created At": formatDateTime(wage?.created_at),
            "Created By": `${wage?.created_by?.first_name} ${wage?.created_by?.last_name}`,
          },
        },

        {
          title: "Payment Details",
          fields: {
            Amount: numberFormat(item?.amount),
            "Payment Method": item?.payment_method,
            Status: <PaymentStatusTag status={item?.status} />,
            "Payment Date": formatDateTime(item?.payment_date),
            "Phone Number": item?.phone_number,
            "Transaction ID": item?.transaction_id,
            Notes: item?.notes,
          },
        },
      ],
    };
  };

  // const initialFilters = {
  //   start_date: null,
  //   end_date: dayjs().format("YYYY-MM-DD"),
  // };

  // const externalFilters = [
  //   {
  //     id: "created_at",
  //     label: "Collection Date Range",
  //     type: "date",
  //     options: [],
  //   },
  // ];

  const tableTitle = "Wages Payment History";
  const activityFilter = "wage_payment";

  return {
    tableColumns,
    tableData,
    // initialFilters,
    // externalFilters,
    tableTitle,
    viewData,
    activityFilter,
  };
};

export default useWagesPaymentHistory;

export const usePaymentHistoryActionsForm = ({ form, data }: any) => {
  const { uploadData, success, error, submitting } = useSet();

  useToasts({
    success,
    error,
    submitting,
    redirect: "reload",
    successMessage: "Wage payments confirmed successfully",
  });
  const showActionForm = true;

  const fields = [
    ...(showActionForm
      ? [
          {
            field_name: "action",
            label: "Action",
            type: "select",
            options_data: [{ name: "Confirm", id: CONFIRMED }],
            props: { required: true },
          },
          {
            field_name: "confirmation_notes",
            label: "Confirmation Notes",
            type: "textarea",
            props: { required: true },
          },
        ]
      : []),
  ];

  function onSubmit(payload: any) {
    if (!data) return null;
    return uploadData({
      api: `${API_WAGE_PAYMENTS_HISTORY}${data?.id}/confirm/`,
      params: { id: data?.id, confirmation_notes: payload?.confirmation_notes },
    });
  }

  const enableSubmit = !!form?.action && !!form?.confirmation_notes;

  return {
    fields,
    onSubmit,
    enableSubmit,
    showActionForm,
    finalStates: [CONFIRMED, REJECTED],
  };
};
